import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InfoIcon from '@mui/icons-material/Info';
import { general } from '../../config.json'
import config from "../../config.json"
// import logoLightMode from '../../Images/waldmonitor_Mono Dunkel.png';
// import logoDarkMode from '../../Images/waldmonitor_Mono Hell.png';
import { createTheme, useTheme } from '@mui/material/styles';
import ShareIcon from '@mui/icons-material/Share';

import { Grid } from '@mui/material';
import Logo from '../logos/Logo';

const logo2 = require('../../ressources/logos/waldmonitor_arnsberg_bigA.png')

export default function NavbarMobile(props: any) {
    const theme = useTheme();

    const handleShareClick = () => {
        props.setLeftSubDrawerOpen(true)
        props.setLeftSubDrawerType("TEILEN")

    }



    return (<>

        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Grid
                        justifyContent="space-between"
                        container
                    // spacing={24}
                    >
                        <Grid item xs={2}>
                            <IconButton
                                size="large"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                // sx={{ mr: 2 }}
                                onClick={() => props.setNavbarMobileOpen(true)}
                            >
                                <MenuIcon />
                            </IconButton>
                        </Grid>

                        <Grid item container xs={10}>
                            <Grid item container alignItems="center">

                                <Box sx={{
                                    // m: 1,
                                    p: 1
                                }}>
                                    <Logo width='160px' imageSource={logo2} urlClick="https://www.arnsberg.de/smart-city/das-modellprojekt/projektportfolio" />


                                </Box>
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={4}>
                            <Grid item container justifyContent="flex-end">

                               

                            </Grid>

                        </Grid> */}
                    </Grid>
                </Toolbar>
            </AppBar>
        </Box>

    </>
    );
}



